import { useParamsSearch } from '@anytag/shared-hooks';
import { AnalyticsInstagramHashtagsSearchSchemaType } from '../schemaTypes';

export const useAnalyticsInstagramHashtagsFilter = () => useParamsSearch<AnalyticsInstagramHashtagsSearchSchemaType>();
